import React from 'react';

import { isDefined, objectValues, silenceError } from '@nfctron/nexus-core';
import { useIsMounted } from '@nfctron/nexus-react';

import NextErrorComponent from 'next/error';

import { orgIntegratorHosts } from '@root/config/misc.config';

import { wrapStaticPropsWithI18n } from '@root/lib/modules/next/next.module';

const orgIntegratorHostsList = objectValues(orgIntegratorHosts).flat();

/**
 * 404 Not Found page component view
 * @constructor
 */
const NotFoundPage = () => {
	const isMounted = useIsMounted();
	const redirectTo = silenceError(() => {
		const wd = typeof window !== 'undefined' ? window : null;
		/** get active host from the list if matching any */
		const activeHost = orgIntegratorHostsList.find((conf) => conf.type === 'host' && wd?.location.host === conf.value)?.value;
		/** remove subdomains from the active host */
		const activeHostRedirect = isDefined(activeHost) ? activeHost.split('.').slice(-2).join('.') : null;
		if (isDefined(activeHostRedirect)) return new URL(`https://${activeHostRedirect}`).href;
		/** get the legacy Pass website URL */
		return wd?.location.hostname.includes('nfctron.com') ? new URL('https://www.nfctron.com').href : null;
	}, null);

	/** redirect all production 404 pages to the legacy Pass website / org integrator main host index */
	React.useEffect(() => {
		if (isDefined(redirectTo)) window.location.assign(redirectTo);
	});

	if (!isMounted || isDefined(redirectTo)) return null;

	return <NextErrorComponent statusCode={404} />;
};

/** page static props */
export const getStaticProps = wrapStaticPropsWithI18n(
	async ({}) => {
		return {
			props: {},
		};
	},
	{
		pathname: '/404',
	},
);

export default NotFoundPage;
